import styled from 'styled-components';

export const Button = styled.button`
  display: block;
  padding: 1.5rem 2em;
  margin: 0 auto;
  background: none;
  border: 2px solid var(--grey);
  color: var(--grey);
  border-radius: 7rem;
  cursor: pointer;
  outline: none;
  font-size: 1.8rem;
  font-weight: bold;
  margin-top: 5rem;
  @media screen and (hover: hover) {
    &:hover {
      border-color: var(--accent);
      color: var(--accent);
    }
  }
  @media screen and (max-width: 800px) {
    font-size: 1.6rem;
  }
`;
